import { themeGet } from 'styled-system'

export const PROGRESS_BAR_VARIANT = {
  DEFAULT: 'default',
  BHU: 'bhu',
  DWB: 'dwb',
}

export const getProgressBarVariant = ({ bhuStatus, dwbProgressBars }) => {
  if (dwbProgressBars) return PROGRESS_BAR_VARIANT.DWB
  if (bhuStatus) return PROGRESS_BAR_VARIANT.BHU
  return PROGRESS_BAR_VARIANT.DEFAULT
}

export const progressBarIndicatorFill = ({ $variant, theme }) => {
  if ($variant === PROGRESS_BAR_VARIANT.BHU) {
    return themeGet('colors.blue')({ theme })
  }
  if ($variant === PROGRESS_BAR_VARIANT.DWB) {
    return themeGet('colors.blueGray')({ theme })
  }
  return null
}
